import React from 'react';
import Tabs from '../Tabs/Tabs';
import ServiceLogPresenterTabContent from './ServiceLogPresenterTabContent';
import ModalButtons from '../ModalButtons/ModalButtons';

export default class ServiceLogPresenter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      active_tab: this.props.active_tab || 'service-log-general',
      service_log: {
        assigned_to: this.props.service_log.assigned_to || null,
        scheduled_at: this.props.service_log.scheduled_at || new Date(),
        setTimeOpen: this.props.service_log.start_time || this.props.service_log.end_time ? true : null,
        startTime: new Date(this.props.service_log.start_time) || null,
        endTime: new Date(this.props.service_log.end_time) || null,
        startedAt: this.props.service_log.started_at || null,
        finishedAt: this.props.service_log.finished_at || null,
        acknowledgedAt: this.props.service_log.acknowledged_at || null,
        createdAt: this.props.service_log.created_at || null,
        description: this.props.service_log.description || null,
        products: this.props.service_log.products || null,
        status: this.props.service_log.status || null,
        room: this.props.reservation_segment && this.props.reservation_segment.room ? this.props.reservation_segment.room : this.props.service_log.room,
        room_type: this.props.service_log.room_type || null,
      },
      reservation_segment: this.props.reservation_segment,
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChangeSetTimeOpen = this.onChangeSetTimeOpen.bind(this)
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
    ]

    return(
      <div className="product-folio-item-builder" ref="root">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          {/* <ServiceLogPresenterTabs {...this.state} onChangeActiveTab={this.onChangeActiveTab} /> */}
          <ServiceLogPresenterTabContent {...this.state}
            reservation_segment = {this.props.reservation_segment}
            service_log_notes_path={this.props.service_log_notes_path}
            time_format={this.props.time_format}
            date_format={this.props.date_format}
            folio_item={this.props.service_log.folio_item}
           />
        </div>
        <ModalButtons loading={this.state.loading} buttons={buttons} />
      </div>

    )
  }

  tabs() {
    var tabs =
      [
        {
          tabName: I18n.t('general'),
          targetName: 'service-log-general',
          classes: this.state.active_tab === 'service-log-general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('room'),
          targetName: 'room',
          classes: this.state.active_tab === 'room' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('assigned_to'),
          targetName: 'assigned_to',
          classes: this.state.active_tab === 'assigned_to' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'service-log-notes',
          classes: this.state.active_tab === 'service-log-notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('status_timeline'),
          targetName: 'status_timeline',
          classes: this.state.active_tab === 'status_timeline' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]

    return tabs
  };

  onChangeSetTimeOpen() {
    let log = Object.assign({}, this.state.service_log)
    if (log.setTimeOpen == false) {
      log.setTimeOpen = true
    } else {
      log.setTimeOpen = false
    }
    this.setState({
      service_log: log,
    })
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

}
